module.exports = __webpack_public_path__ + "img/DerAufprall10.625e8502.jpg";